import { useEffect, useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import RoundedButton from '../../../../../../../../Shared/RoundedButton';
import { setAccountBackendErrors } from '../../../../../../../../../redux_store';

const useStyles = makeStyles((theme) => ({
  footer: {
    display: 'flex',
    justifyContent: 'space-between'
  }
}));


const CptsFooter = ({
                     values,
                     closeModal,
                     form,
                     disabled,
                   }) => {
  const { en: { btn } } = useSelector((state) => state.i18n);
  const classes = useStyles();
  const [previousValues, setPreviousValues] = useState();
  const [previousErrors, setPreviousErrors] = useState();
  const dispatch = useDispatch();
  const { backendErrors } = useSelector((state) => state.accountEditing);
  const setBackendErrors = (newErrors) => {
    dispatch(setAccountBackendErrors(newErrors));
  }

  useEffect(() => {
    setPreviousValues(values)
    setPreviousErrors(backendErrors)
  }, []);

  const closeModalAndResetChanges = async () => {
    await form.setValues(previousValues);
    await setBackendErrors(previousErrors);
    closeModal()
  }

  return <Grid item xs={12} sm={12} className={classes.footer}>
    <RoundedButton
      onClick={closeModalAndResetChanges}
      variant="contained"
      color="secondary"
      size="small"
      className={classes.btn}
    >
      {btn.cancelLastChanges}
    </RoundedButton>
    <RoundedButton
      onClick={closeModal}
      variant="contained"
      color="primary"
      size="small"
      className={classes.btn}
      disabled={disabled}
    >
      {btn.applyChanges}
    </RoundedButton>
  </Grid>;
};

export default CptsFooter;
